<template>
  <div class="body-div">
    <div class="span-center">
      <img class="book-cls" src="../imgs/zhuye.jpg" >
    </div>
    <div class="shade" v-show="!isHidden" @click="hidePanel"></div>
    <div class="center-item" v-show="!isHidden">
      <div class="bcfff div p40 w-80">
        <div class="input_view">
          <div class="left f60 f-blod">{{num}}</div>
          <div class="iconfont icon-backspace-fill right f70" @touchstart="changeActive" @touchend="removeActive" @click="backspace"></div>
        </div>
        <div class="flex-container h130 f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="1" @click="inputNum">1</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="2" @click="inputNum">2</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="3" @click="inputNum">3</div>
        </div>
        <div class="flex-container h130 f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="4" @click="inputNum">4</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="5" @click="inputNum">5</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="6" @click="inputNum">6</div>
        </div>
        <div class="flex-container h130 f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="7" @click="inputNum">7</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="8" @click="inputNum">8</div>
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="9" @click="inputNum">9</div>
        </div>
        <div class="flex-container f-blod f80">
          <div class="flex-1 c000" @touchstart="changeActive" @touchend="removeActive" data-num="0" @click="inputNum">0</div>
        </div>
        <div class="span-right c007948 pt40">
          <div class="right" @click="search" @touchstart="changeActive" @touchend="removeActive">确定</div>
          <div class="mr50 right" @click="hidePanel" @touchstart="changeActive" @touchend="removeActive">取消</div>
        </div>
      </div>
    </div>

    <div class="flex-wrap">
      <div class="select-view" hover-class="select-hover" @click="showPanel">快速选择</div>
    </div>
  </div>
</template>
<script>
import http from '@/util/http.js'
import '@/css/index.css'

export default {
  name: "index",
  data() {
    return {
      num:'',
      isHidden:true,
      code:null
    }
  }, methods: {
    inputNum: function (e) {
      const number = this.num + e.currentTarget.dataset.num;
      if (number.length < 6) {
        this.num = number
      }
    },
    backspace: function () {
      let num = this.num;
      if (num && num.length > 0) {
        num = num.substring(0, num.length - 1);
        this.num = num
      }
    },
    search: function (e) {
      let num = this.num;
      if (!num) {
        this.$toast("请输入数字");
        return;
      }
      if (num == 0) {
        this.$toast("请输入大于0的数字");
        return;
      }
      num = parseInt(num);
      const that = this;
      http.post('/song/getContentsList', { search: num }).then(res=> {
          if (res.code === 0) {
            const list = res.data;
            if (!list || list.length == 0) {
              that.$toast(num + '首不存在');
            } else {
              that.hidePanel();
              that.toSongPage(num, list[0].id, list[0].type);
            }
          } else {
            that.$toast('查找失败，请重试');
          }
        }
      )
    },
    toSongPage: function (num, id, type) {
      this.$router.push({
        name: 'songPage',
        query:{
          number:num,
          id:id,
          type:type
        }
      })
    },
    showPanel: function () {
      this.isHidden = false
      this.num = '';
    },
    hidePanel: function () {
      this.isHidden = true
    },
    changeActive($event){
      $event.currentTarget.className = $event.currentTarget.className +  " c24af08";
    },
    removeActive($event){
      $event.currentTarget.className = $event.currentTarget.className.replace("c24af08","");
    }
  },
  mounted(){
    /*if(!this.$global.isLogin){
      let url = window.location.href;
      let arr = url.split("code=");
      if(arr.length>1){
        this.code = arr[1].split("&")[0];
        this.$global.login(this.code);
      }else{
        http.getWechatCode();
      }
    }*/
  }
}</script>



// WEBPACK FOOTER //
// src/views/index.vue